module.exports = __webpack_public_path__ + "img/genie.044575f0.jpg";